class Range {

    constructor({
                    min = 0,
                    max = 0
                } = {}) {

        this._min = min;
        this._max = max;
    }


    get min() {
        return this._min;
    }

    set min(value) {
        const _value = Number(value);

        if (Number.isNaN(_value)) {
            return null
        }

        if (_value > this._max) {
            this._max = _value
        }
        this._min = _value;
    }

    get max() {
        return this._max;
    }

    set max(value) {
        const _value = Number(value);

        if (Number.isNaN(_value)) {
            return null
        }

        if (_value < this._min) {
            this._min = _value
        }
        this._max = _value;
    }

    inRange(value){
        return value <= this._max && value >= this._min
    }

    toString() {
        return (this._min === this._max) ? this._min : `${this._min} - ${this._max}`

    }

    toFirestore() {
        return {
            min: this._min,
            max: this.max
        }
    }

}

module.exports = Range;